import Vue from 'vue';

Vue.component('Player', () => {
  // добавлена проверка на отображение плеера, в тестовом контуре можно отобразить "фейковый" плеер
  if (process.env.NODE_ENV === 'development') {
    // return import('@/modules/player/Fake.vue');
    return import('@/modules/player/Player.vue');
  } else {
    return import('@/modules/player/Player.vue');
  }
});
